<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $t('messages.dashboard'),
                        href: meta.links.dashboard_index,
                    },
                    {
                        name: $tc('messages.student_file_tags', 2),
                        href: meta.links.index,
                    },
                    {
                        name: studentFileTag.name,
                        href: null,
                    },
                ]"
            />
        </template>

        <div>
            {{ studentFileTag.description }}
        </div>

        <div>
            <ul>
                <li v-for="student in students" :key="student.id">
                    <inertia-link :href="student.links.show" class="text-indigo-500">
                        {{ student.full_name }}
                    </inertia-link>
                </li>
            </ul>
        </div>
    </PanelPage>
</template>

<script>
import AdminLayout from '@/Shared/AdminLayout.vue';
import PanelPage from '@/Shared/PanelPage.vue';

export default {
    components: {
        PanelPage,
    },
    layout: AdminLayout,
    name: 'Edit',
    props: ['teacher', 'meta', 'students', 'studentFileTag'],
    data() {
        return {
            form: this.$inertia.form({
                name: this.studentFileTag.name,
                student_file_tag_category_id: this.studentFileTag.student_file_tag_category_id,
                description: this.studentFileTag.description,
            }),
        };
    },
    methods: {
        submit() {
            this.form.patch(this.meta.links.update);
        },
    },
};
</script>
